import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html {
    scroll-behavior: smooth;
  }

  body {
    font-family: 'Pretendard', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
      'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
      sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    overflow-x: hidden;
    background-color: #020617;
    color: #f8fafc;
  }

  code {
    font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
      monospace;
  }

  a {
    text-decoration: none;
    color: inherit;
  }

  button {
    border: none;
    background: none;
    cursor: pointer;
    font-family: inherit;
  }

  ul, ol {
    list-style: none;
  }

  /* lucide 아이콘: 부모의 font-size/color를 따르도록 통일 */
  svg.lucide {
    width: 1em;
    height: 1em;
    stroke: currentColor;
    flex-shrink: 0;
  }
`;

export const theme = {
  colors: {
    primary: '#ffffff',
    primaryDark: '#e2e8f0',
    primaryLight: '#f8fafc',
    secondary: '#334155',
    secondaryDark: '#1e293b',
    accent: '#7fb0d4',
    success: '#10b981',
    warning: '#f59e0b',
    
    // Backgrounds
    bgPrimary: 'transparent',
    bgSecondary: 'rgba(15, 23, 42, 0.2)',
    bgDark: 'rgba(11, 17, 32, 0.2)',
    bgGradient1: 'linear-gradient(135deg, #0f172a 0%, #020617 100%)',
    bgGradient2: 'linear-gradient(135deg, #1e293b 0%, #0f172a 100%)',
    bgGradient3: 'linear-gradient(135deg, #1e293b 0%, #0B1120 100%)',
    bgGradient4: 'linear-gradient(135deg, #0f172a 0%, #0B1120 100%)',
    
    // Text
    textPrimary: '#f8fafc',
    textSecondary: '#94a3b8',
    textTertiary: '#64748b',
    textLight: '#ffffff',
    
    // Borders
    border: '#1e293b',
    borderDark: '#334155',
  },
  
  shadows: {
    small: '0 2px 4px rgba(0, 0, 0, 0.1)',
    medium: '0 4px 12px rgba(0, 0, 0, 0.1)',
    large: '0 8px 24px rgba(0, 0, 0, 0.12)',
    xlarge: '0 20px 40px rgba(0, 0, 0, 0.15)',
    hover: '0 30px 60px rgba(0, 0, 0, 0.12)',
  },
  
  transitions: {
    fast: 'all 0.2s ease',
    normal: 'all 0.3s ease',
    slow: 'all 0.5s ease',
    cubic: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
  },
  
  breakpoints: {
    mobile: '480px',
    tablet: '768px',
    desktop: '1024px',
    wide: '1280px',
  },
};

export type ThemeType = typeof theme;
